import { Component } from 'ng-metadata/core';

import './loading-state.scss';

@Component({
    selector: 'mw-content-stream-loading-state',
    template: `
        <div class="mw-content-stream-loading-state">
            <svg x="0px" y="0px" width="640px" height="360px" xml:space="preserve">
                <rect x="0" y="0" width="640px" height="400px" style="fill: white; mask: url(#mask)"></rect>
                <mask id="mask" x="0" y="0" width="640px" height="400px">
                    <rect x="0" y="0" style="fill:#ffffff;" width="640" height="400"></rect>
                    <circle cx="78.3" cy="39.4" r="20.2"></circle>
                    <path d="M256.7,33.3H118.2c-3.3,0-6-2.7-6-6v0c0-3.3,2.7-6,6-6h138.6c3.3,0,6,2.7,6,6v0C262.7,30.6,260,33.3,256.7,33.3z"></path>
                    <path d="M558.3,96.4h-494c-3.3,0-6-2.7-6-6v0c0-3.3,2.7-6,6-6h494c3.3,0,6,2.7,6,6v0C564.3,93.7,561.6,96.4,558.3,96.4z"></path>
                    <path d="M558.3,120.7h-494c-3.3,0-6-2.7-6-6v0c0-3.3,2.7-6,6-6h494c3.3,0,6,2.7,6,6v0C564.3,118,561.6,120.7,558.3,120.7z"></path>
                    <path d="M378.3,145.3h-314c-3.3,0-6-2.7-6-6v0c0-3.3,2.7-6,6-6h314c3.3,0,6,2.7,6,6v0C384.3,142.6,381.6,145.3,378.3,145.3z"></path>
                    <path d="M205.3,58.4H118c-3.2,0-5.8-2.6-5.8-5.8v-0.4c0-3.2,2.6-5.8,5.8-5.8h87.3c3.2,0,5.8,2.6,5.8,5.8v0.4C211.1,55.8,208.5,58.4,205.3,58.4z"></path>
                </mask>
            </svg>
        </div>
    `
})
export class LoadingStateComponent {}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/loading-state/loading-state.component.ts